import { render, staticRenderFns } from "./VideoDetailContainer.vue?vue&type=template&id=0eeb8641&scoped=true&"
import script from "./VideoDetailContainer.vue?vue&type=script&lang=js&"
export * from "./VideoDetailContainer.vue?vue&type=script&lang=js&"
import style0 from "./VideoDetailContainer.vue?vue&type=style&index=0&id=0eeb8641&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eeb8641",
  null
  
)

export default component.exports